const Card = ({children, onClick, id}) => <div id={id} className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow p-3 mb-3 cursor-pointer" onClick={onClick}>{children}</div>

export default Card;